import { RootState } from '@/store/types';
import { ActionTree } from 'vuex';
import { MailRegistrationState } from './types';

export const actions: ActionTree<MailRegistrationState, RootState> = {}
